import type { SVGProps } from "react";
const SvgIconExcavator = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" {...props}>
    <circle cx={512} cy={512} r={512} fill="currentColor" />
    <rect width={421.5} height={100} x={128} y={668} rx={50} />
    <path d="m877.19 657-30.14-30.1-54.4-414.08a25 25 0 0 0-41.74-14.07L585.43 362.38a31.7 31.7 0 0 0-5.31 7.49L512 516.52V306a50 50 0 0 0-50-50H356a100 100 0 0 0-100 100v94h-78a50 50 0 0 0-50 50v93a50 50 0 0 0 50 50h334a37.51 37.51 0 0 0 34.27-22.25l88.62-219.89 118.24-130.29 65 327.43L720 768h111.23c57.9 0 86.91-70 45.96-111" />
  </svg>
);
export default SvgIconExcavator;
